<script>
  import SectionTitle from "../../../components/layout/SectionTitle.svelte";
  import Section from "../../../components/layout/Section.svelte";
  import SectionCaption from "../../../components/layout/SectionCaption.svelte";
  import SchedulePeriodicExecutionsDialog from "./SchedulePeriodicExecutionsDialog.svelte";
  import Button from "../../../components/button/Button.svelte";
  import FutureExecutionsList from "./FutureExecutionsList.svelte";
  import Stack from "../../../components/layout/Stack.svelte";
  import ExecutionSchedulesList from "./ExecutionSchedulesList.svelte";
  import PastExecutionsList from "./PastExecutionsList.svelte";
  import ScheduleOneTimeExecutionDialog from "./ScheduleOneTimeExecutionDialog.svelte";

  let isSchedulePeriodicExecutionsDialogOpen = false
  let isScheduleOneTimeExecutionDialogOpen = false
  let currentTab = "upcomingExecutions";
</script>

<Section>
  <SectionTitle>自動実行</SectionTitle>
  <div style="display: flex; justify-content: end; gap: .5rem;">
    <!--<Button type="secondary" onClick={() => isScheduleOneTimeExecutionDialogOpen = true}>一回限りの予定を追加する</Button>-->
    <Button type="primary" onClick={() => isSchedulePeriodicExecutionsDialogOpen = true}>定期的な実行の予定を追加する</Button>
  </div>
  <Stack direction="vertical" gap="1rem">
    <div style="display: flex; border-bottom: 1px solid lightgrey; gap: 1rem; font-size: 1.2rem; color: lightgrey; width: 100%">
      <button
        class="tab"
        class:active={currentTab === "upcomingExecutions"}
        on:click={() => currentTab = "upcomingExecutions"}
      >
        直近の実行予定
      </button>
      <button
        class="tab"
        class:active={currentTab === "pastExecutions"}
        on:click={() => currentTab = "pastExecutions"}
      >
        過去の実行
      </button>
      <button
        class="tab"
        class:active={currentTab === "periodicExecutionSettings"}
        on:click={() => currentTab = "periodicExecutionSettings"}
      >
        定期実行の設定
      </button>
    </div>
    {#if currentTab === "upcomingExecutions"}
      <SectionCaption>
        Auto MPS が自動的に実行されるスケジュールです。直近の予定10件のみが表示されます。
      </SectionCaption>
      <FutureExecutionsList />
    {/if}
    {#if currentTab === "pastExecutions"}
      <SectionCaption>
        Auto MPS の実行履歴です。直近の10件のみが表示されます。
      </SectionCaption>
      <PastExecutionsList />
    {/if}
    {#if currentTab === "periodicExecutionSettings"}
      <ExecutionSchedulesList />
    {/if}
  </Stack>
  {#if isSchedulePeriodicExecutionsDialogOpen}
    <SchedulePeriodicExecutionsDialog
      onClose={() => isSchedulePeriodicExecutionsDialogOpen = false}
    />
  {/if}
  {#if isScheduleOneTimeExecutionDialogOpen}
    <ScheduleOneTimeExecutionDialog
      onClose={() => isScheduleOneTimeExecutionDialogOpen = false}
    />
  {/if}
</Section>

<style>
  .tab {
    cursor: pointer;
  }
  .active {
    color: #0e71eb;
    border-bottom: 1px solid #0e71eb;
  }
</style>
